import { gql } from '@apollo/client';

gql`
  query DropdownOptions(
    $table: String
    $search: String
    $force: Boolean
    $entitlementIds: [Int!]
    $topicIds: [Int!]
    $conditionIds: [Int!]
    $presentationIds: [Int!]
    $productId: Int
  ) {
    admin {
      dropdownOptions(
        table: $table
        search: $search
        force: $force
        entitlementIds: $entitlementIds
        topicIds: $topicIds
        conditionIds: $conditionIds
        presentationIds: $presentationIds
        productId: $productId
      ) {
        key
        value
        description
        metaData {
          key
          value
        }
      }
    }
  }
`;
